import styled from 'styled-components';
import Title from 'js/components/core/SteppedPage/Title';

export default styled(Title)`
  margin-bottom: 2rem;
`;
